import DisconnectModal from './disconnectModal.view';

export default DisconnectModal;
